import { AppMenuItem, MENU_ITEMS } from '../pages/pages-menu';

export interface PagePermissionActions {
  view: boolean;
  edit?: boolean;
  delete?: boolean;
  create?: boolean;
  update?: boolean;
  test?: boolean;
}

export type PagePermissions = Record<string, PagePermissionActions>;

/**
 * Builds permissions in the exact structure consumed by PermissionGuard,
 * PagesComponent and PermissionModalComponent.
 *
 * MENU_ITEMS remains the single source of truth, so newly added menu pages
 * are automatically granted to the first Super Admin.
 */
export function buildAllPagePermissions(
  menuItems: AppMenuItem[] = MENU_ITEMS,
): PagePermissions {
  const permissions: PagePermissions = {};

  const collect = (items: AppMenuItem[]): void => {
    items.forEach((item) => {
      const rawKey =
        item.permissionKey ||
        item.queryParams?.formKey ||
        item.queryParams?.form ||
        item.title;

      const permissionKey = String(rawKey || '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '');

      if (permissionKey) {
        permissions[permissionKey] = permissionKey === 'smtpsettings'
          ? {
              view: true,
              create: true,
              update: true,
              test: true,
            }
          : {
              view: true,
              edit: true,
              delete: true,
            };
      }

      if (Array.isArray(item.children) && item.children.length > 0) {
        collect(item.children);
      }
    });
  };

  collect(menuItems);

  return permissions;
}
